/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UnlinkProviderDto = {
    /**
     * The social provider to unlink
     */
    provider: UnlinkProviderDto.provider;
};
export namespace UnlinkProviderDto {
    /**
     * The social provider to unlink
     */
    export enum provider {
        GOOGLE = 'google',
        APPLE = 'apple',
    }
}

